import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ExpandService } from '../../../core/services/expand.service';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { PageModel, SortModel } from '../../components/task-assignment-list-unassigned/abstract-task-assignment-list';
import { ArticleDataSource } from './articleDataSource';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-articles-list',
  templateUrl: './articles-list.component.html',
  styleUrls: ['./articles-list.component.scss']
})
export class ArticlesListComponent implements OnDestroy, OnInit {

  public dataSource: ArticleDataSource;

  // pagination
  public pageModel: PageModel;
  public defaultPageModel: PageModel = { pageNumber: 0, pageSize : 15 };

  public loading = false;

  // sorting
  public sortModel: SortModel;
  public sortOptions = [];
  public defaultSortModel: SortModel;

  @Input() withMainHeadline = true;
  loadingSubscription: Subscription;

  constructor(
    private apollo: Apollo,
    public expandService: ExpandService,
    private translate: TranslateService
  ) {
    // Initialize translated sortOptions
    this.sortOptions = [
      { label: this.translate.instant('rentModule.articlesListComponent.sortOptions.noSorting'), fieldName: 'id', direction: "asc"},
      { label: this.translate.instant('rentModule.articlesListComponent.sortOptions.numberAsc'), fieldName: 'number', direction: "asc" },
      { label: this.translate.instant('rentModule.articlesListComponent.sortOptions.numberDesc'), fieldName: 'number', direction: "desc" },
      { label: this.translate.instant('rentModule.articlesListComponent.sortOptions.nameAsc'), fieldName: 'name', direction: "asc" },
      { label: this.translate.instant('rentModule.articlesListComponent.sortOptions.nameDesc'), fieldName: 'name', direction: "desc"}
    ];
    this.defaultSortModel = this.sortOptions[0];
    this.pageModel = this.defaultPageModel;
    this.sortModel = this.defaultSortModel;
    this.dataSource = new ArticleDataSource(this.apollo);
    this.loadingSubscription = this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.loadArticles();
  }
  
  ngOnInit() {
    this.expandService.setExpandState(false);
  }

  loadArticles(): void{
    this.dataSource.loadarticles(this.buildQueryVariables());
  }

  refetchArticles(): void {
    this.dataSource.refetchQuery(this.buildQueryVariables());
  }

  buildQueryVariables(): any {
    return {
      pageNumber: this.pageModel?.pageNumber,
      pageSize: this.pageModel?.pageSize,
      sortProperty: this.sortModel?.fieldName,
      sortDirection: this.sortModel?.direction
    };
  }

  ngOnDestroy(): void {
    this.dataSource?.disconnect();
    this.loadingSubscription?.unsubscribe();
  }

  onPageChange(event) {
    this.pageModel = { pageNumber: event.page, pageSize: event.rows };
    this.refetchArticles();
  }
}
